import { Database } from 'lucide-react';
import type { ToolStatus } from './streamChat';

/** Google Drive's multicolor mark (brand colors are the logo itself, not theme colors). */
function GoogleDriveMark() {
  return (
    <svg viewBox="0 0 87.3 78" className="h-3.5 w-3.5 shrink-0" aria-hidden>
      <path d="m6.6 66.85 3.85 6.65c.8 1.4 1.95 2.5 3.3 3.3L27.5 53H0c0 1.55.4 3.1 1.2 4.5z" fill="#0066da" />
      <path d="M43.65 25 29.9 1.2c-1.35.8-2.5 1.9-3.3 3.3L1.2 48.5A9 9 0 0 0 0 53h27.5z" fill="#00ac47" />
      <path d="M73.55 76.8c1.35-.8 2.5-1.9 3.3-3.3l1.6-2.75L86.1 57.5c.8-1.4 1.2-2.95 1.2-4.5H59.8l5.85 11.5z" fill="#ea4335" />
      <path d="M43.65 25 57.4 1.2C56.05.4 54.5 0 52.9 0H34.4c-1.6 0-3.15.45-4.5 1.2z" fill="#00832d" />
      <path d="M59.8 53H27.5L13.75 76.8c1.35.8 2.9 1.2 4.5 1.2h50.8c1.6 0 3.15-.45 4.5-1.2z" fill="#2684fc" />
      <path d="M73.4 26.5 60.7 4.5c-.8-1.4-1.95-2.5-3.3-3.3L43.65 25 59.8 53h27.45c0-1.55-.4-3.1-1.2-4.5z" fill="#ffba00" />
    </svg>
  );
}

/** Gmail's multicolor mark (brand colors are the logo itself, not theme colors). */
function GmailMark() {
  return (
    <svg viewBox="0 0 52 40" className="h-3.5 w-3.5 shrink-0" aria-hidden>
      <path d="M3.5 40h8.1V19.6L0 10.9v25.6C0 38.4 1.6 40 3.5 40z" fill="#4285f4" />
      <path d="M40.4 40h8.1c1.9 0 3.5-1.6 3.5-3.5V10.9l-11.6 8.7z" fill="#34a853" />
      <path d="M40.4 3.5v16.1L52 10.9V5.2c0-4.3-4.9-6.8-8.4-4.2z" fill="#fbbc04" />
      <path d="M11.6 19.6V3.5L26 14.4 40.4 3.5v16.1L26 30.5z" fill="#ea4335" />
      <path d="M0 5.2v5.7l11.6 8.7V3.5L8.4 1C4.9-1.6 0 .9 0 5.2z" fill="#c5221f" />
    </svg>
  );
}

/** Small line naming the connector actually running right now — only from server status frames. */
export function ToolStatusLine({ status }: { status: ToolStatus }) {
  return (
    <span role="status" aria-live="polite" className="ml-7 inline-flex items-center gap-1.5 text-xs text-muted-foreground">
      {status.tool === 'google_drive' ? <GoogleDriveMark /> : status.tool === 'google_mail' ? <GmailMark /> : <Database className="h-3.5 w-3.5 shrink-0" aria-hidden />}
      {status.label}
    </span>
  );
}
